import axios from "./axiosConfig";

interface ChartDataOptions {
  [key: string]: any;
}

export default async function getSiteChartData(
  accessToken: string,
  siteId: string,
  dataType: string,
  options: ChartDataOptions
): Promise<any> {
  const response = await axios.get(
    `/site/${siteId}/chart_data/${dataType}?options=${JSON.stringify(options)}`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  return response.data;
}
